import React from 'react';
import { FinishNewsletterPopup } from '@husky-x/cc-finish-newsletter-popup';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { FinishNewsletterImageForm } from '@phx-husky/cc-finish-newsletter-image-form';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';
import { FinishProductsCards } from '@phx-husky/cc-finish-products-cards';

import {
  FinishNewsletterPopupMock,
  FinishProductCardsMock,
  FinishProductDifferencesMock,
} from './custom-components-mocks';
import CustomProductBenefitsWrapper from './src/components/CustomProductBenefitsWrapper';
import HomePageBannerWrapper from './src/components/HomePageBannerWrapper';
import HowToRecycleBannerWrapper from './src/components/HowToRecycleBannerWrapper';
import CustomHeroBannerWrapper from './src/components/RecyclablePacksHeroBannerWrapper';
import SameFinishPerformanceBannerWrapper from './src/components/SameFinishPerformanceBannerWrapper';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'FinishProductDifferences',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMock} />,
      },
      {
        key: 'FinishProductCards',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMock} />,
      },
      {
        key: 'FinishNewsletterPopup',
        component: () => <FinishNewsletterPopup {...FinishNewsletterPopupMock} />,
      },
      {
        key: 'custom_finish_newsletter_image_form',
        component: FinishNewsletterImageForm,
      },
      {
        key: 'homepage-banner',
        component: HomePageBannerWrapper,
      },
      {
        key: 'custom-product-benefits',
        component: CustomProductBenefitsWrapper,
      },
      {
        key: 'recyclable-packs-hero-banner',
        component: CustomHeroBannerWrapper,
      },

      {
        key: 'same-finish-performance-banner',
        component: SameFinishPerformanceBannerWrapper,
      },

      {
        key: 'how-to-recycle-banner',
        component: HowToRecycleBannerWrapper,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
